module.exports = __webpack_public_path__ + "static/media/equalicare-img25.27804b9f.gif";